"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var routes = {
  '/login': {
    title: 'Log in',
    view: 'Login',
    "public": true,
    locales: {
      az: '/az/login',
      en: '/en/login',
      ru: '/ru/login'
    }
  },
  '/az/login': {
    ref: '/login',
    lang: 'az',
    title: 'Giriş'
  },
  '/en/login': {
    ref: '/login',
    lang: 'en',
    title: 'Log in'
  },
  '/ru/login': {
    ref: '/login',
    lang: 'ru',
    title: 'Войти'
  },
  '/signup': {
    title: 'Sign up',
    view: 'Signup',
    "public": true,
    locales: {
      az: '/az/signup',
      en: '/en/signup',
      ru: '/ru/signup'
    }
  },
  '/az/signup': {
    ref: '/signup',
    lang: 'az',
    title: 'Qeydiyyat'
  },
  '/en/signup': {
    ref: '/signup',
    lang: 'en',
    title: 'Sign up'
  },
  '/ru/signup': {
    ref: '/signup',
    lang: 'ru',
    title: 'Регистрация'
  },
  '/remind': {
    title: 'Remind password',
    view: 'Remind',
    "public": true,
    locales: {
      az: '/az/remind',
      en: '/en/remind',
      ru: '/ru/remind'
    }
  },
  '/az/remind': {
    ref: '/remind',
    lang: 'az',
    title: 'Şifrəni xatırlat'
  },
  '/en/remind': {
    ref: '/remind',
    lang: 'en',
    title: 'Remind password'
  },
  '/ru/remind': {
    ref: '/remind',
    lang: 'ru',
    title: 'Напомнить пароль'
  },
  '/new-password': {
    title: 'New password',
    view: 'NewPassword',
    "public": true,
    locales: {
      az: '/az/new-password',
      en: '/en/new-password',
      ru: '/ru/new-password'
    }
  },
  '/az/new-password': {
    ref: '/new-password',
    lang: 'az',
    title: 'Yeni şifrə'
  },
  '/en/new-password': {
    ref: '/new-password',
    lang: 'en',
    title: 'New password'
  },
  '/ru/new-password': {
    ref: '/new-password',
    lang: 'ru',
    title: 'Новый пароль'
  },
  '/cabinet': {
    title: 'Personal cabinet',
    view: 'Cabinet',
    locales: {
      az: '/az/cabinet',
      en: '/en/cabinet',
      ru: '/ru/cabinet'
    }
  },
  '/az/cabinet': {
    ref: '/cabinet',
    lang: 'az',
    title: 'Şəxsi kabinet'
  },
  '/en/cabinet': {
    ref: '/cabinet',
    lang: 'en',
    title: 'Personal cabinet'
  },
  '/ru/cabinet': {
    ref: '/cabinet',
    lang: 'ru',
    title: 'Личный кабинет'
  },
  '/cabinet/change-password': {
    title: 'Change password',
    view: 'ChangePassword',
    locales: {
      az: '/az/cabinet/change-password',
      en: '/en/cabinet/change-password',
      ru: '/ru/cabinet/change-password'
    }
  },
  '/az/cabinet/change-password': {
    ref: '/cabinet/change-password',
    lang: 'az',
    title: 'Parolu dəyişdir'
  },
  '/en/cabinet/change-password': {
    ref: '/cabinet/change-password',
    lang: 'en',
    title: 'Change password'
  },
  '/ru/cabinet/change-password': {
    ref: '/cabinet/change-password',
    lang: 'ru',
    title: 'Сменить пароль'
  },
  '/cart': {
    title: 'Shopping cart',
    view: 'Cart',
    "public": true,
    locales: {
      az: '/az/cart',
      en: '/en/cart',
      ru: '/ru/cart'
    }
  },
  '/cabinet/verify': {
    title: 'Verify account',
    view: 'CabinetVerify',
    locales: {
      az: '/az/cabinet/verify',
      en: '/en/cabinet/verify',
      ru: '/ru/cabinet/verify'
    }
  },
  '/az/cabinet/verify': {
    ref: '/cabinet/verify',
    lang: 'az',
    title: 'İstifadəçi hesabını təsdiqləyin'
  },
  '/en/cabinet/verify': {
    ref: '/cabinet/verify',
    lang: 'en',
    title: 'Verify account'
  },
  '/ru/cabinet/verify': {
    ref: '/cabinet/verify',
    lang: 'ru',
    title: 'Подтвердите учетную запись'
  },
  '/az/cart': {
    ref: '/cart',
    lang: 'az',
    title: 'Səbət'
  },
  '/en/cart': {
    ref: '/cart',
    lang: 'en',
    title: 'Shopping cart'
  },
  '/ru/cart': {
    ref: '/cart',
    lang: 'ru',
    title: 'Корзина'
  },
  '/wishlist': {
    title: 'Wishlist',
    view: 'Wishlist',
    "public": true,
    locales: {
      az: '/az/wishlist',
      en: '/en/wishlist',
      ru: '/ru/wishlist'
    }
  },
  '/az/wishlist': {
    ref: '/wishlist',
    lang: 'az',
    title: 'İstəklər'
  },
  '/en/wishlist': {
    ref: '/wishlist',
    lang: 'en',
    title: 'Wishlist'
  },
  '/ru/wishlist': {
    ref: '/wishlist',
    lang: 'ru',
    title: 'Избранное'
  },
  '/compare': {
    title: 'Compare',
    view: 'Compare',
    "public": true,
    locales: {
      az: '/az/compare',
      en: '/en/compare',
      ru: '/ru/compare'
    }
  },
  '/az/compare': {
    ref: '/compare',
    lang: 'az',
    title: 'Müqayisə'
  },
  '/en/compare': {
    ref: '/compare',
    lang: 'en',
    title: 'Compare'
  },
  '/ru/compare': {
    ref: '/compare',
    lang: 'ru',
    title: 'Сравнить'
  },
  '/checkout': {
    title: 'Checkout',
    view: 'Checkout',
    "public": true,
    locales: {
      az: '/az/checkout',
      en: '/en/checkout',
      ru: '/ru/checkout'
    }
  },
  '/az/checkout': {
    ref: '/checkout',
    lang: 'az',
    title: 'Sifarişi tamamla'
  },
  '/en/checkout': {
    ref: '/checkout',
    lang: 'en',
    title: 'Checkout'
  },
  '/ru/checkout': {
    ref: '/checkout',
    lang: 'ru',
    title: 'Оформить заказ'
  },
  '/cabinet/orders': {
    title: 'My Orders',
    view: 'CabinetOrders',
    locales: {
      az: '/az/cabinet/orders',
      en: '/en/cabinet/orders',
      ru: '/ru/cabinet/orders'
    }
  },
  '/az/cabinet/orders': {
    ref: '/cabinet/orders',
    lang: 'az',
    title: 'Sifarişlərim'
  },
  '/en/cabinet/orders': {
    ref: '/cabinet/orders',
    lang: 'en',
    title: 'My orders'
  },
  '/ru/cabinet/orders': {
    ref: '/cabinet/orders',
    lang: 'ru',
    title: 'Мои заказы'
  },
  '/cabinet/address': {
    title: 'My address',
    view: 'CabinetAddress',
    locales: {
      az: '/az/cabinet/address',
      en: '/en/cabinet/address',
      ru: '/ru/cabinet/address'
    }
  },
  '/az/cabinet/address': {
    ref: '/cabinet/address',
    lang: 'az',
    title: 'Mənim ünvanım'
  },
  '/en/cabinet/address': {
    ref: '/cabinet/address',
    lang: 'en',
    title: 'My address'
  },
  '/ru/cabinet/address': {
    ref: '/cabinet/address',
    lang: 'ru',
    title: 'Мой адрес'
  },
  '/order': {
    title: 'Order',
    view: 'Order',
    "public": true,
    locales: {
      az: '/az/order',
      en: '/en/order',
      ru: '/ru/order'
    }
  },
  '/az/order': {
    ref: '/order',
    lang: 'az',
    title: 'Sifariş'
  },
  '/en/order': {
    ref: '/order',
    lang: 'en',
    title: 'Order'
  },
  '/ru/order': {
    ref: '/order',
    lang: 'ru',
    title: 'Заказ'
  },
  '/order/error': {
    title: 'Order canceled',
    view: 'OrderError',
    "public": true,
    locales: {
      az: '/az/order/error',
      en: '/en/order/error',
      ru: '/ru/order/error'
    }
  },
  '/az/order/error': {
    ref: '/order/error',
    lang: 'az',
    title: 'Sifariş alınmadı'
  },
  '/en/order/error': {
    ref: '/order/error',
    lang: 'en',
    title: 'Order canceled'
  },
  '/ru/order/error': {
    ref: '/order/error',
    lang: 'ru',
    title: 'Заказ отменен'
  }
};
var _default = exports["default"] = routes;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJyb3V0ZXMiLCJ0aXRsZSIsInZpZXciLCJsb2NhbGVzIiwiYXoiLCJlbiIsInJ1IiwicmVmIiwibGFuZyIsIl9kZWZhdWx0IiwiZXhwb3J0cyJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL2xpYnJhcnkvc3JjL2NsaWVudC9tb2R1bGVzL0F1dGgvQXV0aFJvdXRlcy5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCByb3V0ZXMgPSB7XHJcbiAgICAnL2xvZ2luJzoge1xyXG4gICAgICAgIHRpdGxlOiAnTG9nIGluJyxcclxuICAgICAgICB2aWV3OiAnTG9naW4nLFxyXG4gICAgICAgIHB1YmxpYzogdHJ1ZSxcclxuICAgICAgICBsb2NhbGVzOiB7XHJcbiAgICAgICAgICAgIGF6OiAnL2F6L2xvZ2luJyxcclxuICAgICAgICAgICAgZW46ICcvZW4vbG9naW4nLFxyXG4gICAgICAgICAgICBydTogJy9ydS9sb2dpbidcclxuICAgICAgICB9XHJcbiAgICB9LFxyXG4gICAgJy9hei9sb2dpbic6IHtyZWY6ICcvbG9naW4nLCBsYW5nOiAnYXonLCB0aXRsZTogJ0dpcmnFnyd9LFxyXG4gICAgJy9lbi9sb2dpbic6IHtyZWY6ICcvbG9naW4nLCBsYW5nOiAnZW4nLCB0aXRsZTogJ0xvZyBpbid9LFxyXG4gICAgJy9ydS9sb2dpbic6IHtyZWY6ICcvbG9naW4nLCBsYW5nOiAncnUnLCB0aXRsZTogJ9CS0L7QudGC0LgnfSxcclxuICAgICcvc2lnbnVwJzoge1xyXG4gICAgICAgIHRpdGxlOiAnU2lnbiB1cCcsXHJcbiAgICAgICAgdmlldzogJ1NpZ251cCcsXHJcbiAgICAgICAgcHVibGljOiB0cnVlLFxyXG4gICAgICAgIGxvY2FsZXM6IHtcclxuICAgICAgICAgICAgYXo6ICcvYXovc2lnbnVwJyxcclxuICAgICAgICAgICAgZW46ICcvZW4vc2lnbnVwJyxcclxuICAgICAgICAgICAgcnU6ICcvcnUvc2lnbnVwJ1xyXG4gICAgICAgIH1cclxuICAgIH0sXHJcbiAgICAnL2F6L3NpZ251cCc6IHtyZWY6ICcvc2lnbnVwJywgbGFuZzogJ2F6JywgdGl0bGU6ICdRZXlkaXl5YXQnfSxcclxuICAgICcvZW4vc2lnbnVwJzoge3JlZjogJy9zaWdudXAnLCBsYW5nOiAnZW4nLCB0aXRsZTogJ1NpZ24gdXAnfSxcclxuICAgICcvcnUvc2lnbnVwJzoge3JlZjogJy9zaWdudXAnLCBsYW5nOiAncnUnLCB0aXRsZTogJ9Cg0LXQs9C40YHRgtGA0LDRhtC40Y8nfSxcclxuICAgICcvcmVtaW5kJzoge1xyXG4gICAgICAgIHRpdGxlOiAnUmVtaW5kIHBhc3N3b3JkJyxcclxuICAgICAgICB2aWV3OiAnUmVtaW5kJyxcclxuICAgICAgICBwdWJsaWM6IHRydWUsXHJcbiAgICAgICAgbG9jYWxlczoge1xyXG4gICAgICAgICAgICBhejogJy9hei9yZW1pbmQnLFxyXG4gICAgICAgICAgICBlbjogJy9lbi9yZW1pbmQnLFxyXG4gICAgICAgICAgICBydTogJy9ydS9yZW1pbmQnXHJcbiAgICAgICAgfVxyXG4gICAgfSxcclxuICAgICcvYXovcmVtaW5kJzoge3JlZjogJy9yZW1pbmQnLCBsYW5nOiAnYXonLCB0aXRsZTogJ8WeaWZyyZluaSB4YXTEsXJsYXQnfSxcclxuICAgICcvZW4vcmVtaW5kJzoge3JlZjogJy9yZW1pbmQnLCBsYW5nOiAnZW4nLCB0aXRsZTogJ1JlbWluZCBwYXNzd29yZCd9LFxyXG4gICAgJy9ydS9yZW1pbmQnOiB7cmVmOiAnL3JlbWluZCcsIGxhbmc6ICdydScsIHRpdGxlOiAn0J3QsNC/0L7QvNC90LjRgtGMINC/0LDRgNC+0LvRjCd9LFxyXG4gICAgJy9uZXctcGFzc3dvcmQnOiB7XHJcbiAgICAgICAgdGl0bGU6ICdOZXcgcGFzc3dvcmQnLFxyXG4gICAgICAgIHZpZXc6ICdOZXdQYXNzd29yZCcsXHJcbiAgICAgICAgcHVibGljOiB0cnVlLFxyXG4gICAgICAgIGxvY2FsZXM6IHtcclxuICAgICAgICAgICAgYXo6ICcvYXovbmV3LXBhc3N3b3JkJyxcclxuICAgICAgICAgICAgZW46ICcvZW4vbmV3LXBhc3N3b3JkJyxcclxuICAgICAgICAgICAgcnU6ICcvcnUvbmV3LXBhc3N3b3JkJ1xyXG4gICAgICAgIH1cclxuICAgIH0sXHJcbiAgICAnL2F6L25ldy1wYXNzd29yZCc6IHtyZWY6ICcvbmV3LXBhc3N3b3JkJywgbGFuZzogJ2F6JywgdGl0bGU6ICdZZW5pIMWfaWZyyZknfSxcclxuICAgICcvZW4vbmV3LXBhc3N3b3JkJzoge3JlZjogJy9uZXctcGFzc3dvcmQnLCBsYW5nOiAnZW4nLCB0aXRsZTogJ05ldyBwYXNzd29yZCd9LFxyXG4gICAgJy9ydS9uZXctcGFzc3dvcmQnOiB7cmVmOiAnL25ldy1wYXNzd29yZCcsIGxhbmc6ICdydScsIHRpdGxlOiAn0J3QvtCy0YvQuSDQv9Cw0YDQvtC70YwnfSxcclxuICAgICcvY2FiaW5ldCc6IHtcclxuICAgICAgICB0aXRsZTogJ1BlcnNvbmFsIGNhYmluZXQnLFxyXG4gICAgICAgIHZpZXc6ICdDYWJpbmV0JyxcclxuICAgICAgICBsb2NhbGVzOiB7XHJcbiAgICAgICAgICAgIGF6OiAnL2F6L2NhYmluZXQnLFxyXG4gICAgICAgICAgICBlbjogJy9lbi9jYWJpbmV0JyxcclxuICAgICAgICAgICAgcnU6ICcvcnUvY2FiaW5ldCdcclxuICAgICAgICB9XHJcbiAgICB9LFxyXG4gICAgJy9hei9jYWJpbmV0Jzoge3JlZjogJy9jYWJpbmV0JywgbGFuZzogJ2F6JywgdGl0bGU6ICfFnsmZeHNpIGthYmluZXQnfSxcclxuICAgICcvZW4vY2FiaW5ldCc6IHtyZWY6ICcvY2FiaW5ldCcsIGxhbmc6ICdlbicsIHRpdGxlOiAnUGVyc29uYWwgY2FiaW5ldCd9LFxyXG4gICAgJy9ydS9jYWJpbmV0Jzoge3JlZjogJy9jYWJpbmV0JywgbGFuZzogJ3J1JywgdGl0bGU6ICfQm9C40YfQvdGL0Lkg0LrQsNCx0LjQvdC10YInfSxcclxuICAgICcvY2FiaW5ldC9jaGFuZ2UtcGFzc3dvcmQnOiB7XHJcbiAgICAgICAgdGl0bGU6ICdDaGFuZ2UgcGFzc3dvcmQnLFxyXG4gICAgICAgIHZpZXc6ICdDaGFuZ2VQYXNzd29yZCcsXHJcbiAgICAgICAgbG9jYWxlczoge1xyXG4gICAgICAgICAgICBhejogJy9hei9jYWJpbmV0L2NoYW5nZS1wYXNzd29yZCcsXHJcbiAgICAgICAgICAgIGVuOiAnL2VuL2NhYmluZXQvY2hhbmdlLXBhc3N3b3JkJyxcclxuICAgICAgICAgICAgcnU6ICcvcnUvY2FiaW5ldC9jaGFuZ2UtcGFzc3dvcmQnXHJcbiAgICAgICAgfVxyXG4gICAgfSxcclxuICAgICcvYXovY2FiaW5ldC9jaGFuZ2UtcGFzc3dvcmQnOiB7cmVmOiAnL2NhYmluZXQvY2hhbmdlLXBhc3N3b3JkJywgbGFuZzogJ2F6JywgdGl0bGU6ICdQYXJvbHUgZMmZeWnFn2Rpcid9LFxyXG4gICAgJy9lbi9jYWJpbmV0L2NoYW5nZS1wYXNzd29yZCc6IHtyZWY6ICcvY2FiaW5ldC9jaGFuZ2UtcGFzc3dvcmQnLCBsYW5nOiAnZW4nLCB0aXRsZTogJ0NoYW5nZSBwYXNzd29yZCd9LFxyXG4gICAgJy9ydS9jYWJpbmV0L2NoYW5nZS1wYXNzd29yZCc6IHtyZWY6ICcvY2FiaW5ldC9jaGFuZ2UtcGFzc3dvcmQnLCBsYW5nOiAncnUnLCB0aXRsZTogJ9Ch0LzQtdC90LjRgtGMINC/0LDRgNC+0LvRjCd9LFxyXG4gICAgJy9jYXJ0Jzoge1xyXG4gICAgICAgIHRpdGxlOiAnU2hvcHBpbmcgY2FydCcsXHJcbiAgICAgICAgdmlldzogJ0NhcnQnLFxyXG4gICAgICAgIHB1YmxpYzogdHJ1ZSxcclxuICAgICAgICBsb2NhbGVzOiB7XHJcbiAgICAgICAgICAgIGF6OiAnL2F6L2NhcnQnLFxyXG4gICAgICAgICAgICBlbjogJy9lbi9jYXJ0JyxcclxuICAgICAgICAgICAgcnU6ICcvcnUvY2FydCdcclxuICAgICAgICB9XHJcbiAgICB9LFxyXG5cclxuICAgICcvY2FiaW5ldC92ZXJpZnknOiB7XHJcbiAgICAgICAgdGl0bGU6ICdWZXJpZnkgYWNjb3VudCcsXHJcbiAgICAgICAgdmlldzogJ0NhYmluZXRWZXJpZnknLFxyXG4gICAgICAgIGxvY2FsZXM6IHtcclxuICAgICAgICAgICAgYXo6ICcvYXovY2FiaW5ldC92ZXJpZnknLFxyXG4gICAgICAgICAgICBlbjogJy9lbi9jYWJpbmV0L3ZlcmlmeScsXHJcbiAgICAgICAgICAgIHJ1OiAnL3J1L2NhYmluZXQvdmVyaWZ5J1xyXG4gICAgICAgIH1cclxuICAgIH0sXHJcbiAgICAnL2F6L2NhYmluZXQvdmVyaWZ5Jzoge3JlZjogJy9jYWJpbmV0L3ZlcmlmeScsIGxhbmc6ICdheicsIHRpdGxlOiAnxLBzdGlmYWTJmcOnaSBoZXNhYsSxbsSxIHTJmXNkaXFsyZl5aW4nfSxcclxuICAgICcvZW4vY2FiaW5ldC92ZXJpZnknOiB7cmVmOiAnL2NhYmluZXQvdmVyaWZ5JywgbGFuZzogJ2VuJywgdGl0bGU6ICdWZXJpZnkgYWNjb3VudCd9LFxyXG4gICAgJy9ydS9jYWJpbmV0L3ZlcmlmeSc6IHtyZWY6ICcvY2FiaW5ldC92ZXJpZnknLCBsYW5nOiAncnUnLCB0aXRsZTogJ9Cf0L7QtNGC0LLQtdGA0LTQuNGC0LUg0YPRh9C10YLQvdGD0Y4g0LfQsNC/0LjRgdGMJ30sXHJcblxyXG4gICAgJy9hei9jYXJ0Jzoge3JlZjogJy9jYXJ0JywgbGFuZzogJ2F6JywgdGl0bGU6ICdTyZliyZl0J30sXHJcbiAgICAnL2VuL2NhcnQnOiB7cmVmOiAnL2NhcnQnLCBsYW5nOiAnZW4nLCB0aXRsZTogJ1Nob3BwaW5nIGNhcnQnfSxcclxuICAgICcvcnUvY2FydCc6IHtyZWY6ICcvY2FydCcsIGxhbmc6ICdydScsIHRpdGxlOiAn0JrQvtGA0LfQuNC90LAnfSxcclxuICAgICcvd2lzaGxpc3QnOiB7XHJcbiAgICAgICAgdGl0bGU6ICdXaXNobGlzdCcsXHJcbiAgICAgICAgdmlldzogJ1dpc2hsaXN0JyxcclxuICAgICAgICBwdWJsaWM6IHRydWUsXHJcbiAgICAgICAgbG9jYWxlczoge1xyXG4gICAgICAgICAgICBhejogJy9hei93aXNobGlzdCcsXHJcbiAgICAgICAgICAgIGVuOiAnL2VuL3dpc2hsaXN0JyxcclxuICAgICAgICAgICAgcnU6ICcvcnUvd2lzaGxpc3QnXHJcbiAgICAgICAgfVxyXG4gICAgfSxcclxuICAgICcvYXovd2lzaGxpc3QnOiB7cmVmOiAnL3dpc2hsaXN0JywgbGFuZzogJ2F6JywgdGl0bGU6ICfEsHN0yZlrbMmZcid9LFxyXG4gICAgJy9lbi93aXNobGlzdCc6IHtyZWY6ICcvd2lzaGxpc3QnLCBsYW5nOiAnZW4nLCB0aXRsZTogJ1dpc2hsaXN0J30sXHJcbiAgICAnL3J1L3dpc2hsaXN0Jzoge3JlZjogJy93aXNobGlzdCcsIGxhbmc6ICdydScsIHRpdGxlOiAn0JjQt9Cx0YDQsNC90L3QvtC1J30sXHJcbiAgICAnL2NvbXBhcmUnOiB7XHJcbiAgICAgICAgdGl0bGU6ICdDb21wYXJlJyxcclxuICAgICAgICB2aWV3OiAnQ29tcGFyZScsXHJcbiAgICAgICAgcHVibGljOiB0cnVlLFxyXG4gICAgICAgIGxvY2FsZXM6IHtcclxuICAgICAgICAgICAgYXo6ICcvYXovY29tcGFyZScsXHJcbiAgICAgICAgICAgIGVuOiAnL2VuL2NvbXBhcmUnLFxyXG4gICAgICAgICAgICBydTogJy9ydS9jb21wYXJlJ1xyXG4gICAgICAgIH1cclxuICAgIH0sXHJcbiAgICAnL2F6L2NvbXBhcmUnOiB7cmVmOiAnL2NvbXBhcmUnLCBsYW5nOiAnYXonLCB0aXRsZTogJ03DvHFheWlzyZknfSxcclxuICAgICcvZW4vY29tcGFyZSc6IHtyZWY6ICcvY29tcGFyZScsIGxhbmc6ICdlbicsIHRpdGxlOiAnQ29tcGFyZSd9LFxyXG4gICAgJy9ydS9jb21wYXJlJzoge3JlZjogJy9jb21wYXJlJywgbGFuZzogJ3J1JywgdGl0bGU6ICfQodGA0LDQstC90LjRgtGMJ30sXHJcbiAgICAnL2NoZWNrb3V0Jzoge1xyXG4gICAgICAgIHRpdGxlOiAnQ2hlY2tvdXQnLFxyXG4gICAgICAgIHZpZXc6ICdDaGVja291dCcsXHJcbiAgICAgICAgcHVibGljOiB0cnVlLFxyXG4gICAgICAgIGxvY2FsZXM6IHtcclxuICAgICAgICAgICAgYXo6ICcvYXovY2hlY2tvdXQnLFxyXG4gICAgICAgICAgICBlbjogJy9lbi9jaGVja291dCcsXHJcbiAgICAgICAgICAgIHJ1OiAnL3J1L2NoZWNrb3V0J1xyXG4gICAgICAgIH1cclxuICAgIH0sXHJcbiAgICAnL2F6L2NoZWNrb3V0Jzoge3JlZjogJy9jaGVja291dCcsIGxhbmc6ICdheicsIHRpdGxlOiAnU2lmYXJpxZ9pIHRhbWFtbGEnfSxcclxuICAgICcvZW4vY2hlY2tvdXQnOiB7cmVmOiAnL2NoZWNrb3V0JywgbGFuZzogJ2VuJywgdGl0bGU6ICdDaGVja291dCd9LFxyXG4gICAgJy9ydS9jaGVja291dCc6IHtyZWY6ICcvY2hlY2tvdXQnLCBsYW5nOiAncnUnLCB0aXRsZTogJ9Ce0YTQvtGA0LzQuNGC0Ywg0LfQsNC60LDQtyd9LFxyXG4gICAgJy9jYWJpbmV0L29yZGVycyc6IHtcclxuICAgICAgICB0aXRsZTogJ015IE9yZGVycycsXHJcbiAgICAgICAgdmlldzogJ0NhYmluZXRPcmRlcnMnLFxyXG4gICAgICAgIGxvY2FsZXM6IHtcclxuICAgICAgICAgICAgYXo6ICcvYXovY2FiaW5ldC9vcmRlcnMnLFxyXG4gICAgICAgICAgICBlbjogJy9lbi9jYWJpbmV0L29yZGVycycsXHJcbiAgICAgICAgICAgIHJ1OiAnL3J1L2NhYmluZXQvb3JkZXJzJ1xyXG4gICAgICAgIH1cclxuICAgIH0sXHJcbiAgICAnL2F6L2NhYmluZXQvb3JkZXJzJzoge3JlZjogJy9jYWJpbmV0L29yZGVycycsIGxhbmc6ICdheicsIHRpdGxlOiAnU2lmYXJpxZ9syZlyaW0nfSxcclxuICAgICcvZW4vY2FiaW5ldC9vcmRlcnMnOiB7cmVmOiAnL2NhYmluZXQvb3JkZXJzJywgbGFuZzogJ2VuJywgdGl0bGU6ICdNeSBvcmRlcnMnfSxcclxuICAgICcvcnUvY2FiaW5ldC9vcmRlcnMnOiB7cmVmOiAnL2NhYmluZXQvb3JkZXJzJywgbGFuZzogJ3J1JywgdGl0bGU6ICfQnNC+0Lgg0LfQsNC60LDQt9GLJ30sXHJcbiAgICAnL2NhYmluZXQvYWRkcmVzcyc6IHtcclxuICAgICAgICB0aXRsZTogJ015IGFkZHJlc3MnLFxyXG4gICAgICAgIHZpZXc6ICdDYWJpbmV0QWRkcmVzcycsXHJcbiAgICAgICAgbG9jYWxlczoge1xyXG4gICAgICAgICAgICBhejogJy9hei9jYWJpbmV0L2FkZHJlc3MnLFxyXG4gICAgICAgICAgICBlbjogJy9lbi9jYWJpbmV0L2FkZHJlc3MnLFxyXG4gICAgICAgICAgICBydTogJy9ydS9jYWJpbmV0L2FkZHJlc3MnXHJcbiAgICAgICAgfVxyXG4gICAgfSxcclxuICAgICcvYXovY2FiaW5ldC9hZGRyZXNzJzoge3JlZjogJy9jYWJpbmV0L2FkZHJlc3MnLCBsYW5nOiAnYXonLCB0aXRsZTogJ03JmW5pbSDDvG52YW7EsW0nfSxcclxuICAgICcvZW4vY2FiaW5ldC9hZGRyZXNzJzoge3JlZjogJy9jYWJpbmV0L2FkZHJlc3MnLCBsYW5nOiAnZW4nLCB0aXRsZTogJ015IGFkZHJlc3MnfSxcclxuICAgICcvcnUvY2FiaW5ldC9hZGRyZXNzJzoge3JlZjogJy9jYWJpbmV0L2FkZHJlc3MnLCBsYW5nOiAncnUnLCB0aXRsZTogJ9Cc0L7QuSDQsNC00YDQtdGBJ30sXHJcbiAgICAnL29yZGVyJzoge1xyXG4gICAgICAgIHRpdGxlOiAnT3JkZXInLFxyXG4gICAgICAgIHZpZXc6ICdPcmRlcicsXHJcbiAgICAgICAgcHVibGljOiB0cnVlLFxyXG4gICAgICAgIGxvY2FsZXM6IHtcclxuICAgICAgICAgICAgYXo6ICcvYXovb3JkZXInLFxyXG4gICAgICAgICAgICBlbjogJy9lbi9vcmRlcicsXHJcbiAgICAgICAgICAgIHJ1OiAnL3J1L29yZGVyJ1xyXG4gICAgICAgIH1cclxuICAgIH0sXHJcbiAgICAnL2F6L29yZGVyJzoge3JlZjogJy9vcmRlcicsIGxhbmc6ICdheicsIHRpdGxlOiAnU2lmYXJpxZ8nfSxcclxuICAgICcvZW4vb3JkZXInOiB7cmVmOiAnL29yZGVyJywgbGFuZzogJ2VuJywgdGl0bGU6ICdPcmRlcid9LFxyXG4gICAgJy9ydS9vcmRlcic6IHtyZWY6ICcvb3JkZXInLCBsYW5nOiAncnUnLCB0aXRsZTogJ9CX0LDQutCw0LcnfSxcclxuICAgICcvb3JkZXIvZXJyb3InOiB7XHJcbiAgICAgICAgdGl0bGU6ICdPcmRlciBjYW5jZWxlZCcsXHJcbiAgICAgICAgdmlldzogJ09yZGVyRXJyb3InLFxyXG4gICAgICAgIHB1YmxpYzogdHJ1ZSxcclxuICAgICAgICBsb2NhbGVzOiB7XHJcbiAgICAgICAgICAgIGF6OiAnL2F6L29yZGVyL2Vycm9yJyxcclxuICAgICAgICAgICAgZW46ICcvZW4vb3JkZXIvZXJyb3InLFxyXG4gICAgICAgICAgICBydTogJy9ydS9vcmRlci9lcnJvcidcclxuICAgICAgICB9XHJcbiAgICB9LFxyXG4gICAgJy9hei9vcmRlci9lcnJvcic6IHtyZWY6ICcvb3JkZXIvZXJyb3InLCBsYW5nOiAnYXonLCB0aXRsZTogJ1NpZmFyacWfIGFsxLFubWFkxLEnfSxcclxuICAgICcvZW4vb3JkZXIvZXJyb3InOiB7cmVmOiAnL29yZGVyL2Vycm9yJywgbGFuZzogJ2VuJywgdGl0bGU6ICdPcmRlciBjYW5jZWxlZCd9LFxyXG4gICAgJy9ydS9vcmRlci9lcnJvcic6IHtyZWY6ICcvb3JkZXIvZXJyb3InLCBsYW5nOiAncnUnLCB0aXRsZTogJ9CX0LDQutCw0Lcg0L7RgtC80LXQvdC10L0nfSxcclxufTtcclxuXHJcbmV4cG9ydCBkZWZhdWx0IHJvdXRlcztcclxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxJQUFNQSxNQUFNLEdBQUc7RUFDWCxRQUFRLEVBQUU7SUFDTkMsS0FBSyxFQUFFLFFBQVE7SUFDZkMsSUFBSSxFQUFFLE9BQU87SUFDYixVQUFRLElBQUk7SUFDWkMsT0FBTyxFQUFFO01BQ0xDLEVBQUUsRUFBRSxXQUFXO01BQ2ZDLEVBQUUsRUFBRSxXQUFXO01BQ2ZDLEVBQUUsRUFBRTtJQUNSO0VBQ0osQ0FBQztFQUNELFdBQVcsRUFBRTtJQUFDQyxHQUFHLEVBQUUsUUFBUTtJQUFFQyxJQUFJLEVBQUUsSUFBSTtJQUFFUCxLQUFLLEVBQUU7RUFBTyxDQUFDO0VBQ3hELFdBQVcsRUFBRTtJQUFDTSxHQUFHLEVBQUUsUUFBUTtJQUFFQyxJQUFJLEVBQUUsSUFBSTtJQUFFUCxLQUFLLEVBQUU7RUFBUSxDQUFDO0VBQ3pELFdBQVcsRUFBRTtJQUFDTSxHQUFHLEVBQUUsUUFBUTtJQUFFQyxJQUFJLEVBQUUsSUFBSTtJQUFFUCxLQUFLLEVBQUU7RUFBTyxDQUFDO0VBQ3hELFNBQVMsRUFBRTtJQUNQQSxLQUFLLEVBQUUsU0FBUztJQUNoQkMsSUFBSSxFQUFFLFFBQVE7SUFDZCxVQUFRLElBQUk7SUFDWkMsT0FBTyxFQUFFO01BQ0xDLEVBQUUsRUFBRSxZQUFZO01BQ2hCQyxFQUFFLEVBQUUsWUFBWTtNQUNoQkMsRUFBRSxFQUFFO0lBQ1I7RUFDSixDQUFDO0VBQ0QsWUFBWSxFQUFFO0lBQUNDLEdBQUcsRUFBRSxTQUFTO0lBQUVDLElBQUksRUFBRSxJQUFJO0lBQUVQLEtBQUssRUFBRTtFQUFXLENBQUM7RUFDOUQsWUFBWSxFQUFFO0lBQUNNLEdBQUcsRUFBRSxTQUFTO0lBQUVDLElBQUksRUFBRSxJQUFJO0lBQUVQLEtBQUssRUFBRTtFQUFTLENBQUM7RUFDNUQsWUFBWSxFQUFFO0lBQUNNLEdBQUcsRUFBRSxTQUFTO0lBQUVDLElBQUksRUFBRSxJQUFJO0lBQUVQLEtBQUssRUFBRTtFQUFhLENBQUM7RUFDaEUsU0FBUyxFQUFFO0lBQ1BBLEtBQUssRUFBRSxpQkFBaUI7SUFDeEJDLElBQUksRUFBRSxRQUFRO0lBQ2QsVUFBUSxJQUFJO0lBQ1pDLE9BQU8sRUFBRTtNQUNMQyxFQUFFLEVBQUUsWUFBWTtNQUNoQkMsRUFBRSxFQUFFLFlBQVk7TUFDaEJDLEVBQUUsRUFBRTtJQUNSO0VBQ0osQ0FBQztFQUNELFlBQVksRUFBRTtJQUFDQyxHQUFHLEVBQUUsU0FBUztJQUFFQyxJQUFJLEVBQUUsSUFBSTtJQUFFUCxLQUFLLEVBQUU7RUFBa0IsQ0FBQztFQUNyRSxZQUFZLEVBQUU7SUFBQ00sR0FBRyxFQUFFLFNBQVM7SUFBRUMsSUFBSSxFQUFFLElBQUk7SUFBRVAsS0FBSyxFQUFFO0VBQWlCLENBQUM7RUFDcEUsWUFBWSxFQUFFO0lBQUNNLEdBQUcsRUFBRSxTQUFTO0lBQUVDLElBQUksRUFBRSxJQUFJO0lBQUVQLEtBQUssRUFBRTtFQUFrQixDQUFDO0VBQ3JFLGVBQWUsRUFBRTtJQUNiQSxLQUFLLEVBQUUsY0FBYztJQUNyQkMsSUFBSSxFQUFFLGFBQWE7SUFDbkIsVUFBUSxJQUFJO0lBQ1pDLE9BQU8sRUFBRTtNQUNMQyxFQUFFLEVBQUUsa0JBQWtCO01BQ3RCQyxFQUFFLEVBQUUsa0JBQWtCO01BQ3RCQyxFQUFFLEVBQUU7SUFDUjtFQUNKLENBQUM7RUFDRCxrQkFBa0IsRUFBRTtJQUFDQyxHQUFHLEVBQUUsZUFBZTtJQUFFQyxJQUFJLEVBQUUsSUFBSTtJQUFFUCxLQUFLLEVBQUU7RUFBWSxDQUFDO0VBQzNFLGtCQUFrQixFQUFFO0lBQUNNLEdBQUcsRUFBRSxlQUFlO0lBQUVDLElBQUksRUFBRSxJQUFJO0lBQUVQLEtBQUssRUFBRTtFQUFjLENBQUM7RUFDN0Usa0JBQWtCLEVBQUU7SUFBQ00sR0FBRyxFQUFFLGVBQWU7SUFBRUMsSUFBSSxFQUFFLElBQUk7SUFBRVAsS0FBSyxFQUFFO0VBQWMsQ0FBQztFQUM3RSxVQUFVLEVBQUU7SUFDUkEsS0FBSyxFQUFFLGtCQUFrQjtJQUN6QkMsSUFBSSxFQUFFLFNBQVM7SUFDZkMsT0FBTyxFQUFFO01BQ0xDLEVBQUUsRUFBRSxhQUFhO01BQ2pCQyxFQUFFLEVBQUUsYUFBYTtNQUNqQkMsRUFBRSxFQUFFO0lBQ1I7RUFDSixDQUFDO0VBQ0QsYUFBYSxFQUFFO0lBQUNDLEdBQUcsRUFBRSxVQUFVO0lBQUVDLElBQUksRUFBRSxJQUFJO0lBQUVQLEtBQUssRUFBRTtFQUFlLENBQUM7RUFDcEUsYUFBYSxFQUFFO0lBQUNNLEdBQUcsRUFBRSxVQUFVO0lBQUVDLElBQUksRUFBRSxJQUFJO0lBQUVQLEtBQUssRUFBRTtFQUFrQixDQUFDO0VBQ3ZFLGFBQWEsRUFBRTtJQUFDTSxHQUFHLEVBQUUsVUFBVTtJQUFFQyxJQUFJLEVBQUUsSUFBSTtJQUFFUCxLQUFLLEVBQUU7RUFBZ0IsQ0FBQztFQUNyRSwwQkFBMEIsRUFBRTtJQUN4QkEsS0FBSyxFQUFFLGlCQUFpQjtJQUN4QkMsSUFBSSxFQUFFLGdCQUFnQjtJQUN0QkMsT0FBTyxFQUFFO01BQ0xDLEVBQUUsRUFBRSw2QkFBNkI7TUFDakNDLEVBQUUsRUFBRSw2QkFBNkI7TUFDakNDLEVBQUUsRUFBRTtJQUNSO0VBQ0osQ0FBQztFQUNELDZCQUE2QixFQUFFO0lBQUNDLEdBQUcsRUFBRSwwQkFBMEI7SUFBRUMsSUFBSSxFQUFFLElBQUk7SUFBRVAsS0FBSyxFQUFFO0VBQWlCLENBQUM7RUFDdEcsNkJBQTZCLEVBQUU7SUFBQ00sR0FBRyxFQUFFLDBCQUEwQjtJQUFFQyxJQUFJLEVBQUUsSUFBSTtJQUFFUCxLQUFLLEVBQUU7RUFBaUIsQ0FBQztFQUN0Ryw2QkFBNkIsRUFBRTtJQUFDTSxHQUFHLEVBQUUsMEJBQTBCO0lBQUVDLElBQUksRUFBRSxJQUFJO0lBQUVQLEtBQUssRUFBRTtFQUFnQixDQUFDO0VBQ3JHLE9BQU8sRUFBRTtJQUNMQSxLQUFLLEVBQUUsZUFBZTtJQUN0QkMsSUFBSSxFQUFFLE1BQU07SUFDWixVQUFRLElBQUk7SUFDWkMsT0FBTyxFQUFFO01BQ0xDLEVBQUUsRUFBRSxVQUFVO01BQ2RDLEVBQUUsRUFBRSxVQUFVO01BQ2RDLEVBQUUsRUFBRTtJQUNSO0VBQ0osQ0FBQztFQUVELGlCQUFpQixFQUFFO0lBQ2ZMLEtBQUssRUFBRSxnQkFBZ0I7SUFDdkJDLElBQUksRUFBRSxlQUFlO0lBQ3JCQyxPQUFPLEVBQUU7TUFDTEMsRUFBRSxFQUFFLG9CQUFvQjtNQUN4QkMsRUFBRSxFQUFFLG9CQUFvQjtNQUN4QkMsRUFBRSxFQUFFO0lBQ1I7RUFDSixDQUFDO0VBQ0Qsb0JBQW9CLEVBQUU7SUFBQ0MsR0FBRyxFQUFFLGlCQUFpQjtJQUFFQyxJQUFJLEVBQUUsSUFBSTtJQUFFUCxLQUFLLEVBQUU7RUFBaUMsQ0FBQztFQUNwRyxvQkFBb0IsRUFBRTtJQUFDTSxHQUFHLEVBQUUsaUJBQWlCO0lBQUVDLElBQUksRUFBRSxJQUFJO0lBQUVQLEtBQUssRUFBRTtFQUFnQixDQUFDO0VBQ25GLG9CQUFvQixFQUFFO0lBQUNNLEdBQUcsRUFBRSxpQkFBaUI7SUFBRUMsSUFBSSxFQUFFLElBQUk7SUFBRVAsS0FBSyxFQUFFO0VBQTRCLENBQUM7RUFFL0YsVUFBVSxFQUFFO0lBQUNNLEdBQUcsRUFBRSxPQUFPO0lBQUVDLElBQUksRUFBRSxJQUFJO0lBQUVQLEtBQUssRUFBRTtFQUFPLENBQUM7RUFDdEQsVUFBVSxFQUFFO0lBQUNNLEdBQUcsRUFBRSxPQUFPO0lBQUVDLElBQUksRUFBRSxJQUFJO0lBQUVQLEtBQUssRUFBRTtFQUFlLENBQUM7RUFDOUQsVUFBVSxFQUFFO0lBQUNNLEdBQUcsRUFBRSxPQUFPO0lBQUVDLElBQUksRUFBRSxJQUFJO0lBQUVQLEtBQUssRUFBRTtFQUFTLENBQUM7RUFDeEQsV0FBVyxFQUFFO0lBQ1RBLEtBQUssRUFBRSxVQUFVO0lBQ2pCQyxJQUFJLEVBQUUsVUFBVTtJQUNoQixVQUFRLElBQUk7SUFDWkMsT0FBTyxFQUFFO01BQ0xDLEVBQUUsRUFBRSxjQUFjO01BQ2xCQyxFQUFFLEVBQUUsY0FBYztNQUNsQkMsRUFBRSxFQUFFO0lBQ1I7RUFDSixDQUFDO0VBQ0QsY0FBYyxFQUFFO0lBQUNDLEdBQUcsRUFBRSxXQUFXO0lBQUVDLElBQUksRUFBRSxJQUFJO0lBQUVQLEtBQUssRUFBRTtFQUFVLENBQUM7RUFDakUsY0FBYyxFQUFFO0lBQUNNLEdBQUcsRUFBRSxXQUFXO0lBQUVDLElBQUksRUFBRSxJQUFJO0lBQUVQLEtBQUssRUFBRTtFQUFVLENBQUM7RUFDakUsY0FBYyxFQUFFO0lBQUNNLEdBQUcsRUFBRSxXQUFXO0lBQUVDLElBQUksRUFBRSxJQUFJO0lBQUVQLEtBQUssRUFBRTtFQUFXLENBQUM7RUFDbEUsVUFBVSxFQUFFO0lBQ1JBLEtBQUssRUFBRSxTQUFTO0lBQ2hCQyxJQUFJLEVBQUUsU0FBUztJQUNmLFVBQVEsSUFBSTtJQUNaQyxPQUFPLEVBQUU7TUFDTEMsRUFBRSxFQUFFLGFBQWE7TUFDakJDLEVBQUUsRUFBRSxhQUFhO01BQ2pCQyxFQUFFLEVBQUU7SUFDUjtFQUNKLENBQUM7RUFDRCxhQUFhLEVBQUU7SUFBQ0MsR0FBRyxFQUFFLFVBQVU7SUFBRUMsSUFBSSxFQUFFLElBQUk7SUFBRVAsS0FBSyxFQUFFO0VBQVUsQ0FBQztFQUMvRCxhQUFhLEVBQUU7SUFBQ00sR0FBRyxFQUFFLFVBQVU7SUFBRUMsSUFBSSxFQUFFLElBQUk7SUFBRVAsS0FBSyxFQUFFO0VBQVMsQ0FBQztFQUM5RCxhQUFhLEVBQUU7SUFBQ00sR0FBRyxFQUFFLFVBQVU7SUFBRUMsSUFBSSxFQUFFLElBQUk7SUFBRVAsS0FBSyxFQUFFO0VBQVUsQ0FBQztFQUMvRCxXQUFXLEVBQUU7SUFDVEEsS0FBSyxFQUFFLFVBQVU7SUFDakJDLElBQUksRUFBRSxVQUFVO0lBQ2hCLFVBQVEsSUFBSTtJQUNaQyxPQUFPLEVBQUU7TUFDTEMsRUFBRSxFQUFFLGNBQWM7TUFDbEJDLEVBQUUsRUFBRSxjQUFjO01BQ2xCQyxFQUFFLEVBQUU7SUFDUjtFQUNKLENBQUM7RUFDRCxjQUFjLEVBQUU7SUFBQ0MsR0FBRyxFQUFFLFdBQVc7SUFBRUMsSUFBSSxFQUFFLElBQUk7SUFBRVAsS0FBSyxFQUFFO0VBQWtCLENBQUM7RUFDekUsY0FBYyxFQUFFO0lBQUNNLEdBQUcsRUFBRSxXQUFXO0lBQUVDLElBQUksRUFBRSxJQUFJO0lBQUVQLEtBQUssRUFBRTtFQUFVLENBQUM7RUFDakUsY0FBYyxFQUFFO0lBQUNNLEdBQUcsRUFBRSxXQUFXO0lBQUVDLElBQUksRUFBRSxJQUFJO0lBQUVQLEtBQUssRUFBRTtFQUFnQixDQUFDO0VBQ3ZFLGlCQUFpQixFQUFFO0lBQ2ZBLEtBQUssRUFBRSxXQUFXO0lBQ2xCQyxJQUFJLEVBQUUsZUFBZTtJQUNyQkMsT0FBTyxFQUFFO01BQ0xDLEVBQUUsRUFBRSxvQkFBb0I7TUFDeEJDLEVBQUUsRUFBRSxvQkFBb0I7TUFDeEJDLEVBQUUsRUFBRTtJQUNSO0VBQ0osQ0FBQztFQUNELG9CQUFvQixFQUFFO0lBQUNDLEdBQUcsRUFBRSxpQkFBaUI7SUFBRUMsSUFBSSxFQUFFLElBQUk7SUFBRVAsS0FBSyxFQUFFO0VBQWMsQ0FBQztFQUNqRixvQkFBb0IsRUFBRTtJQUFDTSxHQUFHLEVBQUUsaUJBQWlCO0lBQUVDLElBQUksRUFBRSxJQUFJO0lBQUVQLEtBQUssRUFBRTtFQUFXLENBQUM7RUFDOUUsb0JBQW9CLEVBQUU7SUFBQ00sR0FBRyxFQUFFLGlCQUFpQjtJQUFFQyxJQUFJLEVBQUUsSUFBSTtJQUFFUCxLQUFLLEVBQUU7RUFBWSxDQUFDO0VBQy9FLGtCQUFrQixFQUFFO0lBQ2hCQSxLQUFLLEVBQUUsWUFBWTtJQUNuQkMsSUFBSSxFQUFFLGdCQUFnQjtJQUN0QkMsT0FBTyxFQUFFO01BQ0xDLEVBQUUsRUFBRSxxQkFBcUI7TUFDekJDLEVBQUUsRUFBRSxxQkFBcUI7TUFDekJDLEVBQUUsRUFBRTtJQUNSO0VBQ0osQ0FBQztFQUNELHFCQUFxQixFQUFFO0lBQUNDLEdBQUcsRUFBRSxrQkFBa0I7SUFBRUMsSUFBSSxFQUFFLElBQUk7SUFBRVAsS0FBSyxFQUFFO0VBQWUsQ0FBQztFQUNwRixxQkFBcUIsRUFBRTtJQUFDTSxHQUFHLEVBQUUsa0JBQWtCO0lBQUVDLElBQUksRUFBRSxJQUFJO0lBQUVQLEtBQUssRUFBRTtFQUFZLENBQUM7RUFDakYscUJBQXFCLEVBQUU7SUFBQ00sR0FBRyxFQUFFLGtCQUFrQjtJQUFFQyxJQUFJLEVBQUUsSUFBSTtJQUFFUCxLQUFLLEVBQUU7RUFBVyxDQUFDO0VBQ2hGLFFBQVEsRUFBRTtJQUNOQSxLQUFLLEVBQUUsT0FBTztJQUNkQyxJQUFJLEVBQUUsT0FBTztJQUNiLFVBQVEsSUFBSTtJQUNaQyxPQUFPLEVBQUU7TUFDTEMsRUFBRSxFQUFFLFdBQVc7TUFDZkMsRUFBRSxFQUFFLFdBQVc7TUFDZkMsRUFBRSxFQUFFO0lBQ1I7RUFDSixDQUFDO0VBQ0QsV0FBVyxFQUFFO0lBQUNDLEdBQUcsRUFBRSxRQUFRO0lBQUVDLElBQUksRUFBRSxJQUFJO0lBQUVQLEtBQUssRUFBRTtFQUFTLENBQUM7RUFDMUQsV0FBVyxFQUFFO0lBQUNNLEdBQUcsRUFBRSxRQUFRO0lBQUVDLElBQUksRUFBRSxJQUFJO0lBQUVQLEtBQUssRUFBRTtFQUFPLENBQUM7RUFDeEQsV0FBVyxFQUFFO0lBQUNNLEdBQUcsRUFBRSxRQUFRO0lBQUVDLElBQUksRUFBRSxJQUFJO0lBQUVQLEtBQUssRUFBRTtFQUFPLENBQUM7RUFDeEQsY0FBYyxFQUFFO0lBQ1pBLEtBQUssRUFBRSxnQkFBZ0I7SUFDdkJDLElBQUksRUFBRSxZQUFZO0lBQ2xCLFVBQVEsSUFBSTtJQUNaQyxPQUFPLEVBQUU7TUFDTEMsRUFBRSxFQUFFLGlCQUFpQjtNQUNyQkMsRUFBRSxFQUFFLGlCQUFpQjtNQUNyQkMsRUFBRSxFQUFFO0lBQ1I7RUFDSixDQUFDO0VBQ0QsaUJBQWlCLEVBQUU7SUFBQ0MsR0FBRyxFQUFFLGNBQWM7SUFBRUMsSUFBSSxFQUFFLElBQUk7SUFBRVAsS0FBSyxFQUFFO0VBQWtCLENBQUM7RUFDL0UsaUJBQWlCLEVBQUU7SUFBQ00sR0FBRyxFQUFFLGNBQWM7SUFBRUMsSUFBSSxFQUFFLElBQUk7SUFBRVAsS0FBSyxFQUFFO0VBQWdCLENBQUM7RUFDN0UsaUJBQWlCLEVBQUU7SUFBQ00sR0FBRyxFQUFFLGNBQWM7SUFBRUMsSUFBSSxFQUFFLElBQUk7SUFBRVAsS0FBSyxFQUFFO0VBQWU7QUFDL0UsQ0FBQztBQUFDLElBQUFRLFFBQUEsR0FBQUMsT0FBQSxjQUVhVixNQUFNIn0=